var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3679",
    "data-name": "Rectangle 3679",
    width: 16.182,
    height: 27.542,
    fill: "none",
    stroke: "#de1186",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8232",
    "data-name": "Group 8232",
    transform: "translate(-129.982 -209.475)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3557",
    "data-name": "Rectangle 3557",
    width: 30,
    height: 30,
    transform: "translate(129.982 209.475)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8538",
    "data-name": "Group 8538",
    transform: "translate(136.891 210.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8537",
    "data-name": "Group 8537",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M8.076,5.027h0A7.326,7.326,0,0,0,.75,12.353v7a7.326,7.326,0,1,0,14.653,0v-7A7.326,7.326,0,0,0,8.076,5.027Z",
    transform: "translate(0.014 0.097)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_738",
    "data-name": "Line 738",
    y2: 4.359,
    transform: "translate(8.091 0.765)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_739",
    "data-name": "Line 739",
    y2: 5.701,
    transform: "translate(8.091 8.755)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetDefaultIcon);
export default __webpack_public_path__ + "static/media/asset-default-icon.d91f302e9536ad4203344b98a18128d8.svg";
export { ForwardRef as ReactComponent };